"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authorizeRequest = authorizeRequest;
exports.checkEmailExist = checkEmailExist;
exports.checkTokenValidity = checkTokenValidity;
exports.checkUserExistAPI = checkUserExistAPI;
exports.clearAccessToken = clearAccessToken;
exports.deleteAccount = deleteAccount;
exports.getAccessTokenAPI = getAccessTokenAPI;
exports.getCountryFlagsData = getCountryFlagsData;
exports.getEmailData = getEmailData;
exports.loginWatchers = loginWatchers;
exports.requestDeleteAccount = requestDeleteAccount;
exports.setAccessToken = setAccessToken;
var _effects = require("redux-saga/effects");
var api = _interopRequireWildcard(require("../api/login"));
var actions = _interopRequireWildcard(require("./actions"));
var _selector = require("./selector");
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
var _ApiConst = require("../../../../common/utils/ApiConst");
var _reduxApi = require("../../../../common/api/reduxApi");
var _actions2 = _interopRequireWildcard(require("../../../authService/redux/actions"));
var authActions = _actions2;
var _selector2 = require("../../../commonUtils/redux/selector");
var _utils = require("../../../../common/utils/utils");
var _cookieHelper = require("../../../../common/utils/cookieHelper");
var _uuid = require("uuid");
var authApi = _interopRequireWildcard(require("../../../authService/api/api"));
var _baseAPI = require("../../../../common/api/baseAPI");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable camelcase */

function* getAccessTokenAPI(parameters) {
  try {
    var _mainResponse$body, _parameters$data;
    const {
      params
    } = parameters.data;
    if (!(0, _utils.isMobile)()) {
      yield (0, _effects.put)(actions.GET_ACCESS_TOKEN_API.request());
    }
    const mainResponse = yield (0, _effects.call)(api.callAccessTokenApi, params);
    const {
      accessToken: access_token,
      refreshToken: refresh_token,
      ...rest
    } = (_mainResponse$body = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.body) !== null && _mainResponse$body !== void 0 ? _mainResponse$body : {};
    const updatedTokenData = {
      access_token,
      refresh_token,
      ...rest
    };
    yield (0, _effects.put)(actions.GET_ACCESS_TOKEN_API.success(updatedTokenData));
    yield (0, _effects.put)(actions.OLD_TOKEN_DETAILS_API.success(updatedTokenData));
    if (parameters && parameters !== null && parameters !== void 0 && parameters.data && parameters !== null && parameters !== void 0 && (_parameters$data = parameters.data) !== null && _parameters$data !== void 0 && _parameters$data.onSuccess) {
      var _parameters$data2;
      parameters === null || parameters === void 0 || (_parameters$data2 = parameters.data) === null || _parameters$data2 === void 0 || _parameters$data2.onSuccess(updatedTokenData);
    }
    return updatedTokenData;
  } catch (err) {
    var _parameters$data3;
    yield (0, _effects.put)(actions.GET_ACCESS_TOKEN_API.failure(err));
    if (parameters && parameters !== null && parameters !== void 0 && parameters.data && parameters !== null && parameters !== void 0 && (_parameters$data3 = parameters.data) !== null && _parameters$data3 !== void 0 && _parameters$data3.onFailure) {
      var _parameters$data4;
      parameters === null || parameters === void 0 || (_parameters$data4 = parameters.data) === null || _parameters$data4 === void 0 || _parameters$data4.onFailure(err);
    }
    return err;
  }
}
function* checkUserExistAPI(parameters) {
  try {
    const {
      params
    } = parameters.data;
    yield (0, _effects.put)(actions.CHECK_USER_EXIST_API.request());
    const tokenData = yield (0, _effects.call)(authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.callCheckUserExistApi, params, tokenData);
    yield (0, _effects.put)(actions.CHECK_USER_EXIST_API.success(mainResponse));
    parameters.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.CHECK_USER_EXIST_API.failure(err));
    parameters.data.onFailure(err);
    // handle error
  }
}
function* getEmailData(parameters) {
  try {
    const {
      params
    } = parameters.data;
    yield (0, _effects.put)(actions.GET_EMAIL_DATA_API.request());
    const tokenData = yield (0, _effects.call)(authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getEmailDataApi, params, tokenData);
    yield (0, _effects.put)(actions.GET_EMAIL_DATA_API.success(mainResponse));
    parameters.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_EMAIL_DATA_API.failure(err));
    parameters.data.onFailure(err);
    // handle error
  }
}
function* checkEmailExist(parameters) {
  try {
    const {
      params
    } = parameters.data;
    yield (0, _effects.put)(actions.CHECK_EMAIL_EXIST_API.request());
    const tokenData = yield (0, _effects.call)(authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.callCheckEmailExistApi, params, tokenData);
    yield (0, _effects.put)(actions.CHECK_EMAIL_EXIST_API.success(mainResponse));
    parameters.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.CHECK_EMAIL_EXIST_API.failure(err));
    parameters.data.onFailure(err);
    // handle error
  }
}
function* requestDeleteAccount(requestParam) {
  const {
    params
  } = requestParam.data;
  try {
    yield (0, _effects.put)(actions.REQUEST_DELETE_ACCOUNT_API.request());
    const tokenData = yield (0, _effects.call)(authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.requestDeleteAccount, params, tokenData);
    yield (0, _effects.put)(actions.REQUEST_DELETE_ACCOUNT_API.success(mainResponse));
    requestParam.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.REQUEST_DELETE_ACCOUNT_API.failure(err));
    requestParam.data.onFailure(err);
  }
}
function* deleteAccount(requestParam) {
  const {
    params
  } = requestParam.data;
  try {
    yield (0, _effects.put)(actions.DELETE_ACCOUNT_API.request());
    const tokenData = yield (0, _effects.call)(authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.deleteAccount, params, tokenData);
    yield (0, _effects.put)(actions.DELETE_ACCOUNT_API.success(mainResponse));
    requestParam.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.DELETE_ACCOUNT_API.failure(err));
    requestParam.data.onFailure(err);
  }
}
let isTokenAPICalling = false;
function* checkTokenValidity() {
  try {
    const tokenData = yield (0, _effects.select)((0, _selector.guestOrAccessTokenSelector)());
    if (tokenData && tokenData.token) {
      const decodedAccessTokenData = (0, _jwtDecode.default)(tokenData.token);
      const tokenExpiryTimeStamp = decodedAccessTokenData.exp;
      const currentTimeStamp = Math.floor(new Date() / 1000);
      if (tokenExpiryTimeStamp < currentTimeStamp) {
        const refreshToken = yield (0, _effects.select)((0, _selector.refreshTokenSelector)());
        const expiredAccessToken = tokenData.token;
        if (refreshToken) {
          const tokenAPIStatus = yield (0, _effects.select)((0, _selector.tokenStatusSelector)());
          const loginType = yield (0, _effects.select)((0, _selector2.loginTypeSelector)());
          const apiParams = {
            isRefreshTokenGrant: true,
            refreshToken: refreshToken,
            expiredAccessToken,
            loginType: loginType
          };
          if (_ApiConst.isThereMobile && !tokenAPIStatus && !isTokenAPICalling) {
            isTokenAPICalling = true;
            const response = yield (0, _effects.call)(getAccessTokenAPI, {
              data: {
                params: apiParams
              }
            });
            if (!(response !== null && response !== void 0 && response.access_token)) {
              (0, _actions2.authUserLogOut)({
                data: {
                  requestParams: {
                    refreshToken: refreshToken
                  }
                }
              });
              // eslint-disable-next-line no-throw-literal
              throw {
                errorCode: 61398,
                errorMessage: 'Access Token Expire',
                isForRefreshToken: true,
                response: response
              };
            }
            isTokenAPICalling = false;
          } else if (!_ApiConst.isThereMobile && !tokenAPIStatus) {
            yield (0, _effects.call)(getAccessTokenAPI, {
              data: {
                params: apiParams
              }
            });
          } else {
            /**
             * "tokenAPIStatus" used if the getAccessTokenAPI api call is going on.
             * If api call is going on we will not call this api again.
             * We will check the token status every 100 mili seconds
             * that if we receive the token or not.
             * Once we have updated token available will move forward with the API call with new token.
             * We are holding the token call untill we get the success.
             * if we will want wait the second api will fail due to accesstoken is invalidate.
             * if we will not receive an response from,
             * getAccessTokenAPI api anyway it will not work.
             */

            if (!_ApiConst.isThereMobile) {
              let isTokenAPICallIsGoingOn = true;
              while (isTokenAPICallIsGoingOn) {
                isTokenAPICallIsGoingOn = yield (0, _effects.select)((0, _selector.tokenStatusSelector)());
                yield (0, _effects.delay)(100);
              }
            } else {
              yield (0, _effects.delay)(100);
              yield (0, _effects.call)(checkTokenValidity);
            }
          }
        } else {
          // If refreshToken is not available we will take guestToken.
          // TODO:- add device ID
          //
        }
      }
    } else {
      // If no token available we will take guestToken.
      // TODO:- add device ID
    }
  } catch (error) {
    // console.log('===err checkTokenValidity ', error);
    // to fix the "catch" clauses should do more than rethrow
    // TODO:- add device ID

    if (_ApiConst.isThereMobile) {
      throw error;
    }
  }
}
let isGuestAPiCalling = false;
function* authorizeRequest() {
  if (_ApiConst.isThereMobile) {
    try {
      yield (0, _effects.call)(checkTokenValidity);
      const token = yield (0, _effects.select)((0, _selector.guestOrAccessTokenSelector)());
      // console.log('===authorizeRequest tokenData ', token);
      return token;
    } catch (error) {
      // to fix the "catch" clauses should do more than rethrow
      // error is assigned to err before throw
      const err = error;
      throw err;
    }
  } else {
    const accessToken = (0, _cookieHelper.getDataFromCookieAToB)('kcToken');
    const guestToken = (0, _cookieHelper.getDataFromCookie)('Guest_Token');
    if (!accessToken && (!guestToken || !(0, _baseAPI.checkTokenValidity)(guestToken)) && !isGuestAPiCalling) {
      var _mainResponse$body2, _mainResponse$body3;
      (0, _cookieHelper.setDataToCookie)('deviceId', (0, _uuid.v4)());
      const params = {
        data: {
          onSuccess: () => {},
          onFailure: () => {},
          requestParams: {}
        }
      };
      const mainResponse = yield (0, _effects.takeLatest)((0, _effects.call)(authApi.authGuestToken, params));
      const guestTokenData = {
        accessToken: mainResponse === null || mainResponse === void 0 || (_mainResponse$body2 = mainResponse.body) === null || _mainResponse$body2 === void 0 ? void 0 : _mainResponse$body2.guestToken
      };
      if (mainResponse !== null && mainResponse !== void 0 && (_mainResponse$body3 = mainResponse.body) !== null && _mainResponse$body3 !== void 0 && _mainResponse$body3.guestToken) {
        var _mainResponse$body4;
        (0, _cookieHelper.setDataToCookie)('Guest_Token', mainResponse === null || mainResponse === void 0 || (_mainResponse$body4 = mainResponse.body) === null || _mainResponse$body4 === void 0 ? void 0 : _mainResponse$body4.guestToken);
        yield (0, _effects.put)(authActions.AUTH_GUEST_TOKEN_API.success(guestTokenData));
        isGuestAPiCalling = true;
      } else {
        yield (0, _effects.put)(authActions.AUTH_GUEST_TOKEN_API.failure({}));
        isGuestAPiCalling = false;
      }
    }
    return '';
  }
}
function* clearAccessToken() {
  try {
    yield (0, _effects.put)(actions.GET_ACCESS_TOKEN_API.success(_reduxApi.initialAPIState));
  } catch (err) {}
}
function* setAccessToken(params) {
  try {
    yield (0, _effects.put)(actions.GET_ACCESS_TOKEN_API.success(params === null || params === void 0 ? void 0 : params.data));
    return true;
  } catch (err) {
    return false;
  }
}
function* getCountryFlagsData(parameters) {
  try {
    var _parameters$data5;
    yield (0, _effects.put)(actions.GET_COUNTRY_FLAGS_DATA_API.request());
    const mainResponse = yield (0, _effects.call)(api.getCountryFlagsData);
    yield (0, _effects.put)(actions.GET_COUNTRY_FLAGS_DATA_API.success(mainResponse));
    parameters === null || parameters === void 0 || (_parameters$data5 = parameters.data) === null || _parameters$data5 === void 0 || _parameters$data5.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    var _parameters$data6;
    yield (0, _effects.put)(actions.GET_COUNTRY_FLAGS_DATA_API.failure(err));
    parameters === null || parameters === void 0 || (_parameters$data6 = parameters.data) === null || _parameters$data6 === void 0 || _parameters$data6.onFailure(err);
  }
}
function* loginWatchers() {
  yield (0, _effects.takeLatest)(actions.CHECK_USER_EXIST, checkUserExistAPI);
  yield (0, _effects.takeLatest)(actions.CHECK_EMAIL_EXIST, checkEmailExist);
  yield (0, _effects.takeLatest)(actions.GET_EMAIL_DATA, getEmailData);
  yield (0, _effects.takeLatest)(actions.REQUEST_DELETE_ACCOUNT, requestDeleteAccount);
  yield (0, _effects.takeLatest)(actions.DELETE_ACCOUNT, deleteAccount);
  yield (0, _effects.takeLatest)(actions.SET_ACCESS_TOKEN, setAccessToken);
  yield (0, _effects.takeLatest)(actions.CLEAR_ACCESS_TOKEN, clearAccessToken);
  yield (0, _effects.takeLatest)(actions.GET_COUNTRY_FLAGS_DATA, getCountryFlagsData);
  yield (0, _effects.takeEvery)(actions.GET_ACCESS_TOKEN, getAccessTokenAPI);
}